import React from 'react'
import logo from '@assets/images/logo.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '@components/index'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '@hooks/index'
import { recoveryCodeSchema } from '@yupSchemas/index'
import { IAuthRecoveryCode } from '@interfaces/index'
import { AuthService, errorHandler } from '@services/index'
import { toast } from 'react-toastify'

export default function RecoveryCode(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const location = useLocation()
    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthRecoveryCode>({
        resolver: useYupValidation(recoveryCodeSchema),
    })

    async function sendRecoveryCode(values: IAuthRecoveryCode): Promise<void> {
        setIsLoading(true)
        try {
            await AuthService.sendRecoveryCode({ ...values, email: location.state })
            navigate('/reset-password', { state: { ...values, email: location.state } })
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className='box-recovery-code'>
            <div className="recovery-code__backgound">
                <div className="recovery-code__content">
                    <div className="recovery-code__images">
                        <img src={logo} alt="Logo CNA construtora" className="recovery-code__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Um código de recuperação foi enviado para:</h4>
                    <p className="recovery-email">{location.state}</p>
                    <form id="recovery-code__form" onSubmit={handleSubmit(sendRecoveryCode)}>
                        <div className="recovery-code__inputs">
                            <Controller
                                name="code"
                                defaultValue={''}
                                control={control}
                                render={({ field: { value, onChange } }) => {
                                    return <InputForm size='small' placeholder="Digite o código" label="Código" name="code" value={value} onChange={onChange} />
                                }}
                            />
                            <ErrorForm error={errors.code?.message} />
                        </div>
                        <div className="box-button-recovery">
                            <Button secondary type={'button'} placeholder="Cancelar" onClick={() => navigate('/')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Recuperar senha" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
